export default __webpack_public_path__ + "static/media/bg-img-inspiration@2x.b2c7fa30.png";